import api from "./api";

const scholarshipService = {
    // GET /api/scholarships?academicYear=&student=&status=&schemeType=&search=&page=&limit=
    getAll: (params = {}) => api.get("/scholarships", { params }),
    // GET /api/scholarships/:id
    getById: (id) => api.get(`/scholarships/${id}`),
    // GET /api/scholarships/student/:studentId
    getByStudent: (studentId) => api.get(`/scholarships/student/${studentId}`),
    // GET /api/scholarships/summary?academicYear=
    getSummary: (academicYear) => api.get("/scholarships/summary", { params: { academicYear } }),
    // POST /api/scholarships
    create: (data) => api.post("/scholarships", data),
    // PUT /api/scholarships/:id
    update: (id, data) => api.put(`/scholarships/${id}`, data),
    // DELETE /api/scholarships/:id
    remove: (id) => api.delete(`/scholarships/${id}`),
};

export default scholarshipService;